var _path, _ellipse, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShower = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
    fill: "#BCD9C9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 33.002,
    rx: 18.5,
    ry: 20,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33.002,
    r: 20.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0181 46.5087C38.3495 46.5087 38.5704 46.2878 38.5704 45.9564V24.639C38.5704 22.0986 36.4718 20 33.9314 20C31.5566 20 29.1819 21.9882 28.7953 24.2524C27.4699 24.0868 26.1444 24.3629 25.0399 25.0808C23.7145 25.9092 22.8308 27.1794 22.4995 28.6706C22.4443 28.9467 22.6099 29.278 22.9413 29.3333L33.103 31.6528C33.1582 31.6528 33.1582 31.6528 33.2134 31.6528C33.3239 31.6528 33.4343 31.5976 33.4895 31.5423C33.6 31.4871 33.7105 31.3214 33.7105 31.211C34.3732 28.284 32.6611 25.357 29.8446 24.4733C30.1207 22.7613 32.0537 21.1045 33.9314 21.1045C35.8643 21.1045 37.4659 22.7061 37.4659 24.639V45.9564C37.4659 46.2878 37.6868 46.5087 38.0181 46.5087ZM32.7164 30.4378L23.6592 28.3392C23.9906 27.3451 24.6533 26.5719 25.5369 25.9645C26.5862 25.3017 27.8564 25.0808 29.0714 25.357C31.4462 25.9645 32.9373 28.1183 32.7164 30.4378Z",
    fill: "#EE8322"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0658 33.9169L29.9553 34.5796C29.9001 34.8557 30.121 35.1871 30.3971 35.2423C30.4523 35.2423 30.4523 35.2423 30.5076 35.2423C30.7837 35.2423 31.0046 35.0766 31.0598 34.8005L31.1703 34.1378C31.2255 33.8616 31.0046 33.5303 30.7285 33.4751C30.3971 33.4198 30.121 33.5855 30.0658 33.9169Z",
    fill: "#EE8322"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3892 32.5916L22.2788 33.3095C22.2236 33.5856 22.4445 33.917 22.7206 33.9722C22.7758 33.9722 22.7758 33.9722 22.831 33.9722C23.1072 33.9722 23.3281 33.8065 23.3833 33.5304L23.4938 32.8125C23.549 32.5363 23.3281 32.205 23.052 32.1498C22.7758 32.0945 22.4445 32.3154 22.3892 32.5916Z",
    fill: "#EE8322"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8685 35.4629L25.758 36.1808C25.7028 36.457 25.9237 36.7883 26.1998 36.8436C26.2551 36.8436 26.2551 36.8436 26.3103 36.8436C26.5864 36.8436 26.8073 36.6779 26.8626 36.4018L26.973 35.6838C27.0282 35.4077 26.8073 35.0763 26.5312 35.0211C26.1998 34.9659 25.9237 35.1868 25.8685 35.4629Z",
    fill: "#EE8322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.595 31.4949L26.4846 32.2128C26.4294 32.489 26.6503 32.8203 26.9264 32.8755C26.9816 32.8755 26.9816 32.8755 27.0369 32.8755C27.313 32.8755 27.5339 32.7099 27.5891 32.4337L27.6996 31.7158C27.7548 31.4397 27.5339 31.1083 27.2578 31.0531C26.9264 30.9978 26.6503 31.2188 26.595 31.4949Z",
    fill: "#EE8322"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7957 38.0039L28.6853 38.6666C28.6301 38.9428 28.851 39.2741 29.1271 39.3293C29.1823 39.3293 29.1823 39.3293 29.2375 39.3293C29.5137 39.3293 29.7346 39.1637 29.7898 38.8875L29.9003 38.2248C29.9555 37.9487 29.7346 37.6173 29.4584 37.5621C29.1271 37.5069 28.851 37.6726 28.7957 38.0039Z",
    fill: "#EE8322"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5608 38.0593C21.8369 38.0593 22.0578 37.8936 22.113 37.6175L22.2235 36.8995C22.2787 36.6234 22.0578 36.292 21.7817 36.2368C21.5056 36.1816 21.1742 36.4025 21.119 36.6786L21.0085 37.3965C20.9533 37.6727 21.1742 38.004 21.4503 38.0593C21.5056 38.0593 21.5608 38.0593 21.5608 38.0593Z",
    fill: "#EE8322"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5982 39.5501L24.4878 40.268C24.4325 40.5441 24.6534 40.8755 24.9296 40.9307C24.9848 40.9307 24.9848 40.9307 25.04 40.9307C25.3162 40.9307 25.5371 40.765 25.5923 40.4889L25.7028 39.771C25.758 39.4948 25.5371 39.1635 25.2609 39.1083C24.9296 39.053 24.6534 39.2739 24.5982 39.5501Z",
    fill: "#EE8322"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShower);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-shower.ec9f4a66e11f45630f5306797ac5604a.svg";